import { ref } from 'vue'

// 전역 상태
const show = ref(false)
const message = ref('')
const color = ref('success')
const timeout = ref(3000)

export function useToast() {
  const showToast = (msg, type = 'success', duration = 3000) => {
    message.value = msg
    color.value = type
    timeout.value = duration
    show.value = true
  }

  const success = (msg, duration = 3000) => {
    showToast(msg, 'success', duration)
  }

  const error = (msg, duration = 3000) => {
    showToast(msg, 'error', duration)
  }

  const warning = (msg, duration = 3000) => {
    showToast(msg, 'warning', duration)
  }

  const info = (msg, duration = 3000) => {
    showToast(msg, 'info', duration)
  }

  const close = () => {
    show.value = false
  }

  return {
    show,
    message,
    color,
    timeout,
    showToast,
    success,
    error,
    warning,
    info,
    close
  }
}
